import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
    providedIn: 'root'
})
export class ServicioNotificacionDevolucionMedicamentosService {

    constructor(private requestUrl: ReportesRequestService) { }

    async getEntidadEmpresarial(codigoBaseDatos: string, uncoEntidadEmpresarial: number) {
        try {
            const response = await this.requestUrl.getRequest(
            'entidad-empresarial/datos-entidad',
            [codigoBaseDatos,
                {
                    unco_entidad_empresarial : uncoEntidadEmpresarial
                }
            ]
        );
        return response;

        } catch (e) {
            console.error(e);
        }
    return null;
    }

    async getDataReporte(codigoBaseDatos: string, unco_admsn: number, json: string){

        try {

            const response = await this.requestUrl.getRequest(
                'reporte-notificacion-devolucion-medicamento/data',
                [
                    codigoBaseDatos,
                    {
                        json : json
                    }
                ]
            );
        return response;
        } catch (e) {
            console.error(e);
        }

    return null;
    }

    async getDataEncabezado(codigoBaseDatos: string, unco_admsn: number){

        try {

            const response = await this.requestUrl.getRequest(
                'reporte-notificacion-devolucion-medicamento/dataEncabezado',
                [
                    codigoBaseDatos,
                    {
                        unco_admsn: unco_admsn
                    }
                ]
            );
        return response;
        } catch (e) {
            console.error(e);
        }

    return null;
    }

}

export interface ParametrosNotificacionDevolucionMedicamentosEntity {
    codigoBaseDatos: string;
    uncoSede: string;
    uncoLogin: number;
    uncoEntidad: number;
    uncoAdm: number;
}

export interface EntidadEmpresarial {
    unco: number;
    nombreEntidad: string;
    nit: string;
    digitoVerificacion: string;
    direccion: string;
    telefono: string;
}

export interface DataSolicitudSuministrosBodyEntity {
    numeroAdmision: string;
    numeroSolicitud: string;
    codigo: string;
    medicamento: string;
    descripcionBodega: string;
    descripcionLaboratorio: string;
    descripcionSuministro: string;
    numerLote: string;
    cantidadSolicitada: number;
    cantidadEntregada: number;
    cantidadConsumida: number;
    cantidadRequerida: number;
    cantidadDevuelta: number;
    cantidadPendienteDevolucion: number;
    fechaVencimiento: Date;
}

export interface DataEncabezadoSolicitudSuministrosEntity {
    descripcionSede: string;
    consecutivoAdm: string;
    nombreAfiliado: string;
    numeroIdentificacion: string;
    codigo: string;
}
